<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">وكلاء العقارية</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">وكلاء العقارية</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('agents_create')" class="row">
          <div class="col text-end">
            <router-link to="/agent" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة وكيل
            </router-link>
          </div>
        </div>
        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center mb-4 mt-5">
          <div class="col-12 col-md-11">
            <errorAlert v-if="hasError" :alertMessage= "message" />
            <table class="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">الصورة</th>
                  <th scope="col">الاسم</th>
                  <th scope="col">الحاله</th>
                  <th scope="col">اخر تحديث</th>
                  <th v-if="checkAccess('agents_update')" scope="col">التعديل</th>
                  <th v-else scope="col">مشاهدة</th>
                  <th v-if="checkAccess('agents_delete')" scope="col">الحذف</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in rows" :key="index">
                  <td class="counter"></td>
                  <td class="align-con">
                    <img :src="BASE_URL+'uploads/'+row.avatar" clasS="img-thumbnail grid-img" alt="">
                  </td>
                  <td class="align-con">{{ row.name }}</td>
                  <td class="align-con">{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                  <td class="align-con">{{ $shortDate(row.updatedAt) }}</td>
                  <td v-if="checkAccess('agents_update')" class="align-con">
                    <router-link :to="'/agentupdate/'+row.id">
                      <i class="bi bi-card-list"></i>
                    </router-link>
                  </td>
                  <td v-else class="align-con">
                    <router-link :to="'/agent/view/'+row.id"><i class="fa-regular fa-eye"></i></router-link>
                  </td>
                  <td v-if="checkAccess('agents_delete')" class="align-con">
                    <a @click.prevent="deleteItem(index, row.id)">
                      <i class="bi bi-archive text-red"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row mt-3">
              <div class="col">
                <ul class="pagination">
                  <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                  <li v-for="p in pages" :key="p" class="page-item">
                    <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                    <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                  </li>
                  <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';
export default {
  name: "agentview",
  data(){
    return {
      hasError: false,
      message: "",
      isLoading: false,
      rows: [],
      currentPage: 1,
      pages: [],
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods: {
    checkAccess,
    getList() {
      this.hasError = false;
      this.isLoading = true;
      this.$http.get(`/api/admin/agents/list?page=${this.currentPage}`).then(res => {
        this.rows = res.data.agents;
        this.pages = res.data.pages ?? [this.currentPage];
        this.isLoading = false;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },

    deleteItem(index, id) {
      this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/agents/delete/${id}`).then(({data}) => {
            this.rows.splice(index, 1);
            toast('تم حذف السجل بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف السجل');
          });
        }
      });
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
  },
  created() {
    this.getList();
  }
}
</script>